import { Button, Chip, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Autocomplete, createFilterOptions } from "@mui/material";
import CustomToastMessage from "components/common/CustomToastMessage";
import api from "components/settings/api";
import { useOnClickOutside } from "hooks/useOnClickOutside";
import React, { useEffect, useRef, useState } from "react";
import { Bounce, toast } from "react-toastify";
import theme from "styles/themeMui/theme";

function SkillTagInput({ skill, setSkillInput, handleChange }, ref) {
  const useStyles = makeStyles((theme) => ({
    root: {
      "& > *": {
        margin: theme.spacing(1, "auto"),
      },
    },
    input: {
      position: "relative",
      "& > *": {
        margin: theme.spacing(1),
        fontSize: "80px",
        width: "30ch",
        padding: "5px",
        marginTop: "15px",
        [theme.breakpoints.down("md")]: {
          padding: "0",
          width: "70%",
        },
      },
    },
  }));

  const [optionsApi, setoptionsApi] = useState([]);
  const [Skills, setSkills] = useState(skill ? skill : []);
  const [skillsError, setSkillsError] = useState(false);
  const [open, setOpen] = useState(false);
  const [inputValuee, setinputValuee] = useState("");
  const [shouldHandleEnter, setShouldHandleEnter] = useState(true);
  const classes = useStyles(theme);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const isMaxSkillsReached = Skills.length >= 3;

  const [isFocused, setIsFocused] = useState(false);
  const label = isFocused ? "Skills (Max 3)" : "Skills";
  const [notifiedValue, setNotifiedValue] = useState(null);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  useEffect(() => {
    try {
      api.get("/api/v1/profiles/skills").then((item) => {
        setoptionsApi(item?.data);
      });
    } catch (error) {}
  }, []);

  const [notificationDisplayed, setNotificationDisplayed] = useState(false);
  const reactDiv = document.querySelector(".autocomplete-dropdown");
  // State updates on input
  const notify = (message, callback) => {
    if (!notificationDisplayed) {
    toast.error(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
      onClose: () => {
        setNotificationDisplayed(false);
        if (callback) callback();
      },
    });
    setNotificationDisplayed(true);
    }
  }

  const handleChangeSkills = (value) => {
    
    if (value.length > 3) {
      setOpen(false);
      notify("You may only select up to three skills");
    } else {
      checkData(value);
      setSelectedSkills(value)
      setSkillInput(selectedSkills)
    }
  };

  const handleChangeSkillsKeyEnter = (value) => {
    if (Skills.length > 3) {
      setOpen(false);
      notify("You may only select up to three skills");
    } else {
      setOpen(true);
      if (!Array.isArray(value)) {
        value = [value];
      }
      let allSkills = [...Skills, value];
      checkData(allSkills);
    }
  };
  
  const checkData = (value) => {
    setSkills(value);
    setSkillInput(value);
  };

  const checkSkills = () => {
    if (Skills.length > 3) {
      notify("You may only select up to three skills");
    } else {
      setOpen(true);
    }
  };
  const filter = createFilterOptions();

  useEffect(() => {
    let data = Skills[0] + "," + Skills[1] + "," + Skills[2];
    setSkillInput(data);
  }, [Skills]);

  const autocompleteRef = useRef();
  const modalContainerRef = useOnClickOutside(() => setOpen(false));
  
  // useEffect(() => {
  //   window.addEventListener("click", (event) => {
  //     if (
  //       autocompleteRef.current &&
  //       autocompleteRef.current.contains(event.target)
  //     ) {
  //       setOpen(false);
  //     } else {
  //       checkSkills();
  //       return;
  //     }
  //   });

  //   return () => {
  //     window.removeEventListener("click", event);
  //   };
  // }, []);

  useEffect(() => {
    if (notifiedValue) {
      notify("You may only select up to three skills", () => {
        setOpen(false);
      });
      setNotifiedValue(null);
    }
  }, [notifiedValue]);

  const checkSkillsInInput = () => {
    if (Skills.length >= 3) {
    } else {
      setOpen(true);
    }
  };

  return (
    <Autocomplete
      ref={autocompleteRef}
      clearIcon={false}
      open={open}
      // onFocus={() => checkSkills()}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      variant="outlined"
      fullWidth
      size="small"
      id="tags-outlined"
      limitTags={3}
      style={{ zIndex: 1002 }}
      multiple={true}
      aria-label="Tags"
      options={optionsApi?.map((item) => item.skill)}
      value={Skills}
      onChange={(event, value) => {
        if (value.length > 3){
          setNotifiedValue(value);
        } else {
          handleChangeSkills(value)
          if (Skills.length < 3) {
            setOpen(true)
          }
        }
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          if (Skills.length < 3) {
            setShouldHandleEnter(true);
            handleChangeSkillsKeyEnter(inputValuee);
          } else {
            event.preventDefault();
            notify("You may only select up to three skills");
          }    
        }
      }}
      disableCloseOnSelect={Skills.length >= 3}
      freeSolo={false}
      popupIcon={""}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        setinputValuee(inputValue);
        return filtered;
      }}
      className={classes.input}
      
      renderTags={(value, getTagProps) =>
        value.map((skillname, index) => (
          <Chip
            clickable
            {...getTagProps({ index })}
            onChange={() => checkSkills()}
            onBlur={() => checkSkills()}
            label={skillname}
            key={index}
            className="profile--chips"
            style={{ zIndex: 1002 }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          // ref={modalContainerRef}
          className="profile--input_autocomplete-signup"
          style={{ width: "100%" }}
          label={label}
          variant="outlined"
          type="text"
          name="skill"
          autoComplete="off"
          onChange={(event) => {
              if (isMaxSkillsReached) {
                notify("You may only select up to three skills");
              }
            }}
          // value={skill}
          minLength="3"
          maxLength="20"
          placeholder={isMaxSkillsReached ? "" : "Design, Translation, Programming, Music"}
          helperText={skillsError && "Please enter at least 3 characters"}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-label="Tags"
        />
      )}
      noOptionsText={
        optionsApi.length !== 0 ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <span style={{ color: "rgba(0,0,0,.5)", fontFamily: "sans-serif" }}>
              Press Enter To Add "{inputValuee}"
            </span>
          </div>
        ) : (
          "No options"
        )
      }
    />
  );
}

export default React.forwardRef(SkillTagInput);
